import React, { useState } from 'react';
import Questions from '../components/QuestionList';
import { db } from '../firebase-config' //import database
import { addDoc, collection } from 'firebase/firestore'; //import collection
import VerticalLinearStepper from '../components/Stepper';
import { Grid, Container, Box } from '@mui/material'
import NavigationBar from '../components/small_components/NavigationBar';
import Footer from '../components/small_components/Footer';

function Questionnaire() {

  var today = new Date()
  var currentDateTime = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate() + "_" + today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds()

  //State
  const [language, setLanguage] = useState('questions')
  const [currentQuestion, setCurrentQuestion] = useState(0)
  const [state, setState] = useState({
    timeSent: currentDateTime
  })

  //Handle language change
  const handleLanguage= (evt) => {
    if(evt.target.checked) {
      setLanguage(evt.target.value)
    } else {
      setLanguage('questions')
    }
  }

//Reference to users collection in firebase db
const usersCollectionRef = collection(db, "users")

//Function to throw data into database
const createUser = async () => {
  await addDoc(usersCollectionRef, state);
}

  return (
    <div>
    <NavigationBar 
      setLanguage = {setLanguage}
      handleLanguage = {handleLanguage}
    />
    <Container maxWidth='xl'>
      <Grid container
        justifyContent="center">
        <Grid item
          xs={12}
          sm={12}>
          <VerticalLinearStepper
            currentQuestion={currentQuestion}
            language={language}
          />
        </Grid>
        <Grid item xs={12}>
          <Box display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            minHeight="70vh"
            gap="24px"
          >
            <Questions
              state={state}
              setState={setState}
              language={language}
              currentQuestion={currentQuestion}
              setCurrentQuestion={setCurrentQuestion}
              createUser = {createUser}
            />
          </Box>
        </Grid>
      </Grid>
    </Container>
    <Footer />
    </div>
  )

}

export default Questionnaire;